import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  .inputBase {
    margin-left: 5px;
    flex: 1;
  }
  .input {
    padding: 2px 4px;
    height: 36px;
    width: 170px;
    border-radius: 4px;
    margin: 0px 5px;
    background-color: #fafafa;
    box-shadow: none;
  }
  .inputTextStyle {
    text-align: left;
    letter-spacing: 0;
    color: #707891;
    padding: 10px 0;
    width: 200px;
  }
  .inputTextStyleDate {
    text-align: left;
    letter-spacing: 0;
    color: #707891;
    padding: 5px 0;
  }
  .MuiIconButton-root {
    padding: 0px;
  }

  .search-button {
    width: 36px;
    height: 36px;
    background: #f9be00 0% 0% no-repeat padding-box;
    border: 1px solid #f9be00;
    border-radius: 4px;
  }

  .refresh-button {
    width: 36px;
    height: 36px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #efefef;
    border-radius: 4px;
    margin-left: 8px;
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  .inputTextStyleDate {
    text-align: left;
    letter-spacing: 0;
    color: #707891;
    padding: 5px 0;
  }
  .MuiIconButton-root {
    padding: 0px;
  }
  .Mui-focused {
    background-color: none;
  }
  .error-message {
    height: 20px;
  }
`;
